import { type ReactNode, useMemo } from 'react';

import { type MessageDescriptor, useIntl } from 'react-intl-next';

import type { FallbackUrl, GlobalShortcutLinkItem } from '../../types';

export const useAppGlobalShortcutLinkItem = (
	icon: ReactNode,
	label: MessageDescriptor,
	fallbackUrl: FallbackUrl,
	options?: Pick<GlobalShortcutLinkItem, 'labelElem' | 'apsKey'>,
): GlobalShortcutLinkItem => {
	const { labelElem, apsKey } = options ?? {};
	const { formatMessage } = useIntl();

	return useMemo(
		() => ({
			icon,
			label: formatMessage(label),
			labelElem,
			apsKey,
			fallbackUrl,
		}),
		[apsKey, fallbackUrl, formatMessage, icon, label, labelElem],
	);
};
